import React, { useContext, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DataGrid, esES, GridActionsCellItem } from "@mui/x-data-grid";
import { FindInPage } from '@mui/icons-material';
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../app/store/root";
import { ModalComponent } from "../../app/common/ModalComponent";
import ModalDetalles from "../../shared/modals/ModalDetalles";

const GuiasEmbarque = () => {
    const rootStore = useContext(RootStoreContext);
    const { entity } = rootStore.embarqueStore
    const { getById } = rootStore.shipmentStore
    // TABLE
    const columns = [
        {
            field: 'numeroGuia',
            headerName: 'No. de guía',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                  No. de guía
                </span>
              ),
        },
        {
            field: 'proveedor',
            headerName: 'Nombre del proveedor',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                  Nombre del proveedor
                </span>
              ),
        },
        {
            field: 'destino',
            headerName: 'Empresa destino',
            flex: 1,
            headerClassName: 'tableHeaders',
            renderHeader: () => (
                <span className="headerTable">
                  Empresa destino
                </span>
              ),
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            headerClassName: 'tableHeaders',
            getActions: (params) => [
                <Tooltip title="Ver Detalle" placement="top">
                    <GridActionsCellItem
                        icon={<FindInPage />}
                        label="Detalle"
                        color='primary.main'
                        onClick={() => detalleEnvio(params.row)}
                    />
                </Tooltip>,
            ],
        },
    ];

    const [pageSize, setPageSize] = React.useState(5);
    const [showModalDetail, setShowModalDetail] = useState(false);

    const detalleEnvio = async (row) => {
        rootStore.logisticBackdropStore.openLoading()
        await getById(row.idGuia)
        setShowModalDetail(true)
        rootStore.logisticBackdropStore.closeLoading()
    }

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") 
            return;
        setShowModalDetail(false)
    }

    return (
        <Box>
            <Accordion elevation={1}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="guias-content" id="guias-header">
                    <Typography variant="h6" color={"primary.main"}>Guías del embarque</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{
                        width: '100%',
                        '& .tableHeaders': {
                            color: 'primary.main',
                        },
                    }}>

                        <DataGrid
                            getRowId={(row) => row.idGuia}
                            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                            autoHeight
                            rows={entity.envios}
                            columns={columns}
                            dataSource={entity.envios}
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[5, 10, 20]}
                            pagination />
                    </Box>
                </AccordionDetails>
            </Accordion>
            <ModalComponent
                Open={showModalDetail}
                HandleClose={handleClose}
                ClassName="modal-xl"
                Body={() => (
                    <ModalDetalles
                        onClose={handleClose}
                    />
                )}
            />
        </Box>
    );
}

export default observer(GuiasEmbarque)